import { DBNotifications } from '@/shared/apis/bgnotifications'

export enum ToastType {
  SUCCESS = 'SUCCESS',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export type AppNotification = {
  id: string
  profileAddress?: string
  type: ToastType
  message: string
  system: boolean
  method: DBNotifications
  isPersistent: boolean
  path?: string
}

export type NotificationType = 'warning' | 'error' | 'lukso'
